import React, {useState, useEffect} from 'react'
import './App.css';
import Home from './Components/Home';
import Navbar from './Components/Navbar';
import Company from './Components/Company';
import Services from './Components/Services'
import Work from './Components/Work';
import Clients from './Components/Clients'
import Contact from './Components/Contact'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from './Components/Footer';
import PreLoader from './Components/Preloader';

function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1500); 
  }, []);


  return (
    <div className="App">
      {loading ? <PreLoader /> : <div>

      <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={ <Home /> } />
        <Route path="/about-company" element={<Company /> } />
        <Route path="/our-services" element={ <Services /> } />
        <Route path="/our-work" element={ <Work /> } />
        <Route path="/our-clients" element={ <Clients /> } />
        <Route path="/contact" element={ <Contact /> } />
      </Routes>

      <Footer />
        
      </Router>
      </div>}
    </div>
  );
}

export default App;
